import { render } from "./functional_information_receivedByIdView.vue?vue&type=template&id=ff18b962"
import script from "./functional_information_receivedByIdView.vue?vue&type=script&lang=js"
export * from "./functional_information_receivedByIdView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__